import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { IoMdArrowRoundBack } from "react-icons/io";
import { useState } from 'react';
import { useEffect } from 'react';
import { getHardwareDetails, PostRmUpdatedAmount } from 'API/CspMapping/api';
import BackdropLoader from '../../General/Loader';
import SnackBar from '../../General/SnackBar';
import UnMappedAgentTable from './RequestData';
import ApprovalDialog from './ApprovalDialog';
import Modal from '@mui/material/Modal';
import { IoClose } from "react-icons/io5";
import RmApproveDialog from './RmApprovalDialog';
import ApprovalHistory from './ApprovalHistoryModal';
import ReajectReason from '../Components/ReajectReasonBox';
import {  CsoApproveHardwareRequest, HandleApproveDeposit, HandleRejectDeposit } from 'API/DS_Wallet/api';
import HardwareSelectTable from '../Components/HardwareSelecteList';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};


const ApprovePage = (props) => {

    const [Data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [ErrorMessage, setErrorMessage] = useState(null)
    const [AlertType, setAlertType] = useState("success")
    const [AlertOpen, setAlertOpen] = useState(false)

    const [openApprovalDialog, setApprovalDialog] = useState(false)
    const [SelectedData, setSelectedData] = useState(null)
    const [viewLocations, setViewLocations] = useState(false)
    const [RmpostData, setRmpostData] = useState(null)
    const [OpenConfirmApprove, setConfirmApprove] = useState(false)
    const [OpenApprovalHistory, setOpenApprovalHistory] = useState(false)
    const [AgentDetails, setAgentDetails] = useState(null)
    const [openReject, setOpenReject] = useState(false)
    const [RejectReason, setRejectReason] = useState('')
    const [openSelecteDevices, setOpenSelectedDevices] = useState(false)
    const [SelecteDevice, setSelectedDevice] = useState(false)


    const handleOpenSelectedDevices = () => {
        setOpenSelectedDevices(true)
    }

    const handleCloseSelectedDevices = () => {
        setOpenSelectedDevices(false)
    }



    const handleRejectClose = () => {
        setOpenReject(false)
    }

    const handleReject = () => {
        if (RejectReason && RejectReason !== "") {
            HandleRejectDeposit({ request_id: props.userData.request_id, rejected_reason: RejectReason }, setIsLoading, handleErrorOpen)
        }
        else {
            handleErrorOpen("Please enter reason for rejection", "error")
        }
    }




    const handleCloseApprovalClose = () => {
        setOpenApprovalHistory(false)
    }

    const handleOpenViewModal = () => {
        setViewLocations(true)
    }

    const handleCloseViewModal = () => {
        setViewLocations(false)
    }


    const handleRejectOpen = () => {
        setOpenReject(true)
    }


    const handleErrorOpen = (message, type) => {
        setErrorMessage(message)
        setAlertType(type)
        setAlertOpen(true)
    }

    const handleCsoOpenApproveAlert=()=>{
        setConfirmApprove(true)
    }


    useEffect(() => {
        if (sessionStorage.getItem("UserType") === "ph" || sessionStorage.getItem("UserType") === "rm" || sessionStorage.getItem("UserType") === "cso") {
            getHardwareDetails(props.userData, setIsLoading, setData, handleErrorOpen)
        }
    }, [])

    const handleAlertClose = () => {
        setAlertOpen(false)
    }

    const handleApprovalDialogClose = () => {
        setApprovalDialog(false)
    }



    const handleConfirmApproveClose = () => {
        setConfirmApprove(false);
    }

    const handleRMApprove = () => {
        if (sessionStorage.getItem("UserType") === "rm") {
            let updatedArray = Object.entries(RmpostData).map(([key, value]) => {
                return { user_id: key, rm_amount: value };
            });
            let postData = {
                "request_id": props.userData.request_id,
                "ds_id": props.userData.ds_id,
                "agent_data": updatedArray
            }

            PostRmUpdatedAmount(postData, setIsLoading, handleErrorOpen)
        }
        else {
            let postData = { "request_id": props.userData.request_id }
            CsoApproveHardwareRequest(postData, setIsLoading, handleErrorOpen)
        }


    }


    const handleApproveRequest = () => {
        let postdata = { "request_id": props.userData.request_id}
        if (sessionStorage.getItem("UserType") === "rev") {
            HandleApproveDeposit(postdata,handleErrorOpen, setIsLoading )
        }

    }

    return (
        <Grid container>
            <HardwareSelectTable isLoading={isLoading} selected={SelecteDevice} data={Data ? Data : []} open={openSelecteDevices} handleClose={handleCloseSelectedDevices} setSelectedDevice={setSelectedDevice} handleSubmit={handleApproveRequest} />
            <ReajectReason rejectReason={RejectReason} open={openReject} handleClose={handleRejectClose} setRejectReason={setRejectReason} handleReject={handleReject} />
            <RmApproveDialog open={OpenConfirmApprove} handleClose={handleConfirmApproveClose} handleSubmit={handleRMApprove} isLoading={isLoading}/>
            <ApprovalDialog dsdata={props.userData} data={SelectedData} open={openApprovalDialog} handleClose={handleApprovalDialogClose} />
            <ApprovalHistory data={AgentDetails} open={OpenApprovalHistory} handleClose={handleCloseApprovalClose} />
            <BackdropLoader open={isLoading} />
            <SnackBar open={AlertOpen} message={ErrorMessage} type={AlertType} handleClose={handleAlertClose} />
            <Grid item xl={12} lg={12}>
                <Button onClick={() => props.handleClose()} sx={{ fontSize: "20px" }}>
                    <IoMdArrowRoundBack />
                </Button>
                <MainCard>
                    <Modal
                        open={viewLocations}
                        onClose={handleCloseViewModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <Box onClick={() => handleCloseViewModal()} sx={{ position: 'absolute', top: 5, right: 5, fontSize: '25px', cursor: 'pointer' }}>
                                <IoClose />
                            </Box>
                            <Typography id="modal-modal-description" >
                                {props ? props.userData.ds_allocated_location.map((item) => item.District).join(" , ") : null}
                            </Typography>
                        </Box>
                    </Modal>
                    <Grid container>
                        <Grid item xl={12} lg={12}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table" size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: "30%" }} align="left">Name</TableCell>
                                            <TableCell sx={{ width: "10%" }} align="left">Location</TableCell>
                                            <TableCell sx={{ width: "10%" }} align="left">Transaction Mode</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        <TableRow
                                        >
                                            <TableCell sx={{ width: "30%" }} align="left">{props.userData.ds_details.username}</TableCell>
                                            <TableCell align="left" sx={{ width: '30%', height: "1000%" }}>
                                                {/* <Box sx={{ display: 'flex', width: "100%",flexWrap:'wrap' }}> */}
                                                <Button onClick={() => handleOpenViewModal()}>view</Button>
                                                {/* </Box> */}
                                            </TableCell>
                                            <TableCell sx={{ width: "30%" }} align="left">{props.userData.transaction_type}</TableCell>

                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </MainCard>
            </Grid>
            <Grid item xl={12} lg={12} mt={1}>
                <UnMappedAgentTable setAgentDetails={setAgentDetails} setRmpostData={setRmpostData} userDetails={props.userData} setSelectedData={setSelectedData} data={Data ? Data : null} setSelectedDevice={setSelectedDevice} />
            </Grid>
            {
                props.button?
                <Grid item xl={12} lg={12} mt={2}>
                {
                        <Stack direction="row" justifyContent="center" gap={1}>
                            <Button variant="contained" color="success" onClick={() => handleOpenSelectedDevices()} >
                                Approve
                            </Button>
                            <Button variant="contained" color="error" onClick={() => handleRejectOpen()} >
                                Reject
                            </Button>
                        </Stack>

                }

                {
                    sessionStorage.getItem("UserType") === "cso" ?
                    <Stack direction="row" justifyContent="center" gap={1}>
                        <Button variant="contained" color="success" onClick={() => handleCsoOpenApproveAlert()} >
                            Approve
                        </Button>
                        <Button variant="contained" color="error" onClick={() => handleRejectOpen()} >
                            Reject
                        </Button>
                    </Stack>
                    :
                    null
                }

            </Grid>
            :
            null

            }

        </Grid>
    )
}

export default ApprovePage